<template>
	<div class="row d-flex justify-content-center align-items-center">
		<div class="col-12 text-center">
			<h5>Ügyfél adatok</h5>
		</div>

		<div class="col-12" v-if="task && task.id">
			<table class="table table-striped table-responsive-md">
				<thead>
					<tr>
						<td>Aktív</td>
						<td>Név</td>
						<td>Régió</td>
						<td>Cím</td>
						<td>Szállítási cím</td>
						<td>Telefonszám</td>
						<td>E-mail</td>
						<td>Kategória</td>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<span class="text-success" v-show="~~task.aktiv === 1">
								<i class="fas fa-check"></i>
							</span>
							<span class="text-danger" v-show="~~task.aktiv === 0">
								<i class="fas fa-times"></i>
							</span>
						</td>
						<td>{{ task.nev }}</td>
						<td>{{ task.regio }}</td>
						<td v-show="task.cim_utca !== ``">{{ cim }}</td>
						<td v-show="task.cim_utca === ``"> {{ cimOld}} </td>
						<td v-show="task.szal_cim_utca !== ``"> {{ szalcim }} </td>
						<td v-show="task.szal_cim_utca === ``"> {{ szalcimOld}} </td>
						<td>{{ task.telm }}<br>{{ task.telv }}</td>
						<td>
							{{ task.email }}<br>
							{{ task.emaila }}
						</td>
						<td>{{ task.kategoria }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="col-12" v-else>
			<div class="row d-flex justify-content-center">
				<div class="col-6">
					<p>
						<label class="h5">
							Ügyfél keresés
						</label>
						<label class="small">
							Kezdd el gépelni a keresett ügyfél nevét vagy címét
						</label>
					</p>
					<input type="text" class="form-control" v-model="search">		
				</div>
				<div class="col-6">
					<p class="h5">
						Kiválasztott ügyfél
					</p>
					<p class="h4">
						{{ partner }}
					</p>
				</div>
			</div>

			<div class="col-12 mt-2 mb-2" v-show="isSearch">
				<div class="table-wrapper mt-2">
					<table class="table table-hover">
				        <thead class="sticky-top bg-light">
				          	<tr>
					          	<th scope="col">#</th>
					            <th scope="col">Név</th>
					            <th scope="col">Régió</th>
					            <th scope="col">Város</th>
					            <th scope="col">Cím</th>
				          	</tr>
				        </thead>
				        <tbody>
				          	<tr
					          	v-for="(v,k) in customers"
					          	:key="`c-${k}`"
					          	:class="[v.aktiv == '1' ? 'table-success' : '']"
				          	>
					          	<td>
					          		<button
					          			class="btn btn-outline-primary"
					          			@click.prevent="setPartner(v)"
					          		>
					          			Kiválaszt
					          		</button>
					          	</td>
					            <td>{{v.nev}}</td>
					            <td>{{v.regio}}</td>
					            <td>{{v.varos}}</td>
					            <td>{{v.cim}}</td>
				          	</tr>
				        </tbody>
				    </table>
				</div>
			</div>
		</div>

		<div class="col-12 col-md-8 col-lg-6 text-center" v-if="task && task.inquiring==1">
			<router-link
                :to="`/inquiring/edit/${task.uszam}`" target="_blank"
            >
                <button class="btn btn-outline-primary">
                    Érdeklődő adatok módosítása
                </button>
            </router-link>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	props: ['task'],

	data() {
		return {
			search: '',
			partner: '',
			customers: [],
			isSearch: false
		}
	},

	created() {
		this.searchcustomer = _.debounce(this.checkSearch, 500)
	},

	methods: {
		checkSearch(val) {
			this.$Progress.start()
			this.req.post('/customers/search/neworder2',{
				search: {
					nev: this.search,
					cim: this.search,
					cim_utca: this.search,
					varos: this.search
				}
			})
			.then(res => {
				this.customers = res.data.customers
			  	this.$Progress.finish()
			  	this.isSearch = true
			})
			.catch(err => {
				toastr.error(err)
				this.$Progress.fail()
				this.isSearch = false
			})
		},

		setPartner(item) {
			/*this.$emit('update', {
				partner: item.nev,
				uszam: item.uszam
			})*/
			this.isSearch = false
		},
	},

	watch: {
		search() {
      		this.searchcustomer()
    	}
	},

	computed: {
		cim() {
			return `${this.task.iszam}, ${this.task.varos}, ${this.task.cim_utca} ${this.task.cim_hsz} ${this.task.cim_ea}`
		},

		cimOld() {
			return `${this.task.iszam}, ${this.task.varos}, ${this.task.cim}`
		},

		szalcim() {
			return `${this.task.szaliszam}, ${this.task.szalvaros}, ${this.task.szal_cim_utca} ${this.task.szal_cim_hsz} ${this.task.szal_cim_ea}`
		},

		szalcimOld() {
			return `${this.task.szaliszam}, ${this.task.szalvaros}, ${this.task.szalcim}`
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/tasks/taskCustomer.vue